/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import type { Language } from "./types";

export const LANGUAGES: Language[] = [
  { id: "en", name: "English" },
  { id: "de", name: "Deutsch" },
  { id: "fr", name: "Français" },
  { id: "es", name: "Español" },
  { id: "pt", name: "Português" },
  { id: "it", name: "Italiano" },
];

export const BREAKPOINT = 1132;

/*
 * Session 423 / F-13 — HEADER_HIDDEN_PRODUCTS IS GONE, and it is deleted rather
 * than left unused.
 *
 * It named two active products by name and three components read it. That is
 * the same shape as the three curated lists IND-7 / PR-1 removed, for the same
 * reason: a rename in Django admin broke every copy silently, and nothing here
 * could notice. The decision now lives on the product row as
 * `show_in_header_menu`, is published by `product-header/`, and is read through
 * `isShownInHeaderMenu()` in src/lib/productCatalogue/productCatalogue.ts.
 *
 * Do not reintroduce a name list here. The Deskshare Support Forum draws its
 * own product menu from the same catalogue and carried its own copy of these
 * two names for the same reason; publishing the field is what lets both sides
 * delete their copy instead of keeping two lists in step by hand.
 */

export const CART_ICON_SVG_PATH =
  "M25.945 6.68125C25.8276 6.54582 25.6825 6.43722 25.5194 6.36282C25.3564 6.28841 25.1792 6.24993 25 6.25H7.72625L7.4825 4.795C7.43398 4.50312 7.28349 4.23792 7.05781 4.04657C6.83212 3.85523 6.54588 3.75014 6.25 3.75H3.4375C3.10598 3.75 2.78804 3.8817 2.55362 4.11612C2.3192 4.35054 2.1875 4.66848 2.1875 5C2.1875 5.33152 2.3192 5.64946 2.55362 5.88388C2.78804 6.1183 3.10598 6.25 3.4375 6.25H5.19125L7.51625 20.205L7.5725 20.36L7.64 20.5487L7.79 20.7725L7.90875 20.9125L8.15 21.075L8.29 21.1562C8.43565 21.2161 8.59129 21.2479 8.74875 21.25H22.5C22.8315 21.25 23.1495 21.1183 23.3839 20.8839C23.6183 20.6495 23.75 20.3315 23.75 20C23.75 19.6685 23.6183 19.3505 23.3839 19.1161C23.1495 18.8817 22.8315 18.75 22.5 18.75H9.80875L9.60125 17.5H23.75C24.0508 17.5 24.3415 17.3916 24.5688 17.1946C24.7961 16.9976 24.9448 16.7252 24.9875 16.4275L26.2375 7.6775C26.263 7.50018 26.25 7.31945 26.1996 7.14757C26.1491 6.97568 26.0623 6.81665 25.945 6.68125ZM23.5588 8.75L23.2025 11.25H18.75V8.75H23.5588ZM17.5 8.75V11.25H13.75V8.75H17.5ZM17.5 12.5V15H13.75V12.5H17.5ZM12.5 8.75V11.25H8.75L8.565 11.2875L8.1425 8.75H12.5ZM8.7675 12.5H12.5V15H9.18375L8.7675 12.5ZM18.75 15V12.5H23.0225L22.6662 15H18.75Z";

export const CART_CIRCLE_1 =
  "M10.625 26.25C11.6605 26.25 12.5 25.4105 12.5 24.375C12.5 23.3395 11.6605 22.5 10.625 22.5C9.58947 22.5 8.75 23.3395 8.75 24.375C8.75 25.4105 9.58947 26.25 10.625 26.25Z";

export const CART_CIRCLE_2 =
  "M21.875 26.25C22.9105 26.25 23.75 25.4105 23.75 24.375C23.75 23.3395 22.9105 22.5 21.875 22.5C20.8395 22.5 20 23.3395 20 24.375C20 25.4105 20.8395 26.25 21.875 26.25Z";
